import { OptionGroup, Select, SelectOption } from '@payaca/ambrosia';
import { FC, useMemo } from 'react';

import { Address, PartialAddress } from '@payaca/types/locationTypes';
import { AddressLookupOrInput } from '../addressLookupOrInput/AddressLookupOrInput';

export const AddressSelectExistingOrInputNew: FC<{
  addressOptions: SelectOption<number, PartialAddress>[];
  addressOptionGroups?: OptionGroup[];
  onChange?: (value: {
    existingAddressId?: Address['id'];
    newAddress?: PartialAddress;
    latitude?: number;
    longitude?: number;
  }) => void;
  value: {
    existingAddressId?: Address['id'];
    newAddress?: PartialAddress;
    latitude?: number;
    longitude?: number;
  };
  disableManualEdit?: boolean;
  canRevertToExisting?: boolean;
}> = ({
  addressOptions,
  addressOptionGroups,
  onChange,
  value,
  disableManualEdit,
  canRevertToExisting,
}) => {
  const options: SelectOption<Address['id'] | string>[] = useMemo(() => {
    return [
      ...addressOptions,
      {
        value: 'add-new',
        label: 'Add a different address',
        groupId: '',
      },
    ];
  }, [addressOptions]);

  if (value.newAddress) {
    return (
      <AddressLookupOrInput
        address={value.newAddress}
        onChange={(v) => {
          onChange?.({
            newAddress: v,
          });
        }}
        onClear={
          canRevertToExisting
            ? () => onChange?.({ newAddress: undefined })
            : undefined
        }
        disableManualEdit={disableManualEdit}
      />
    );
  }

  return (
    <Select
      value={value.existingAddressId}
      options={options}
      optionGroups={addressOptionGroups}
      onChange={(value) => {
        const selectedOption = options.find((o) => o.value === value);
        if (value === 'add-new') {
          onChange?.({
            existingAddressId: undefined,
            newAddress: {},
          });
        } else {
          onChange?.({
            existingAddressId: value as number,
            latitude:
              (selectedOption?.metadata &&
                'latitude' in selectedOption.metadata &&
                (selectedOption.metadata.latitude as number)) ||
              undefined,
            longitude:
              (selectedOption?.metadata &&
                'longitude' in selectedOption.metadata &&
                (selectedOption.metadata.longitude as number)) ||
              undefined,
          });
        }
      }}
    />
  );
};
